const stringQuestionIntervalToArray = (str) => {
  // Handle undefined, null, or empty string cases
  if (!str || typeof str !== 'string' || str.trim() === '') {
    return [];
  }
  
  const [start, end] = str.split("-").map(Number);
  
  // Validate that we have valid numbers
  if (isNaN(start) || isNaN(end) || start > end) {
    return [];
  }
  
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};

export default stringQuestionIntervalToArray;
